import Vue from 'vue'
import Toast from './Toast.vue'

const createElement = (marker, tag) => {
  let el = document.createElement(tag || 'div')
  el.setAttribute(marker, '')
  document.body.appendChild(el)
}

const timeout = (duration, result) => {
  return new Promise(resolve => setTimeout(() => resolve(result), duration))
}

function CommonToast () {
  let vm

  function showToast (title, tips, duration) {
    if (vm && vm.getState() > 0) {
      vm.update({
        title: title,
        tips: tips
      })

      setTimeout(() => {
        vm.hide()
      }, duration || 1500)
      return
    }
    createElement('von-loading')
    vm = new Vue(Toast).$mount('[von-loading]')
    vm.show({
      title: title,
      tips: tips
    })

    return timeout(duration || 1500).then(() => {
      return vm.hide()
    })
  }

  function hide () {
    if (vm) vm.hide()
  }

  function update (options) {
    vm.update(options)
  }

  return {
    showToast,
    hide,
    update
  }
}

let loading = new CommonToast()

const $CommonToast = {
  show: loading.showToast,
  hide: loading.hide
}

export default $CommonToast
